/** The one-time owner sign-in token carried in the site URL's fragment (see siteSignIn.ts). */
const PARAM = 'tpv_signin';

export function buildSiteSignInUrl(siteUrl: string, tokenHash: string): string {
  return `${siteUrl.replace(/\/+$/, '')}/#${PARAM}=${encodeURIComponent(tokenHash)}`;
}

/** The token in a location hash such as "#tpv_signin=abc", or null. */
export function readSiteSignInToken(hash: string): string | null {
  const match = hash.match(new RegExp(`^#${PARAM}=([^&]+)$`));
  if (!match) return null;
  const token = decodeURIComponent(match[1]);
  return /^[A-Za-z0-9_-]{16,200}$/.test(token) ? token : null;
}
